module.exports = __webpack_public_path__ + "img/banner102.a896ce67.jpeg";